import { render, staticRenderFns } from "./positions.vue?vue&type=template&id=25fd7c68&scoped=true"
import script from "./positions.vue?vue&type=script&lang=ts"
export * from "./positions.vue?vue&type=script&lang=ts"
import style0 from "./styles/scoped.scss?vue&type=style&index=0&id=25fd7c68&prod&lang=scss&scoped=true&external"
import style1 from "./positions.vue?vue&type=style&index=1&id=25fd7c68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd7c68",
  null
  
)

export default component.exports